export default "__VITE_ASSET__9CmPwEg6__"